import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { FileRepository } from "../../shared/domain/FileRepository";
import { DeliverAndCreateChargeForServiceCard } from "./DeliverAndCreateChargeForServiceCard";
import { DeliverAndCreateChargeForServiceTransfer } from "./DeliverAndCreateChargeForServiceTransfer";

export class DeliverAndCreateChargeForService {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly file_repo: FileRepository,
    private readonly frontend
  ) {}

  async run(payment_method, services, org_id, payment_file, promotional_code, num_credits_custom?, user_contract?, user_contract_facturae?): Promise<{ [key: string]: string; }> {
    let res
    if(payment_method=='card'){
        res  = await new DeliverAndCreateChargeForServiceCard(this.dispatcher)
            .run(services, org_id)
        if(payment_method=='transfer'){
            this.frontend.charge_id = 'charge_uuid';
        }
    }
    if(payment_method=='transfer'){
        res = await new DeliverAndCreateChargeForServiceTransfer(this.dispatcher,this.file_repo)
            .run(services, org_id, payment_file, promotional_code, num_credits_custom, user_contract, user_contract_facturae)
    }
    this.frontend.closeContractModal()
    await this.frontend.forceRefreshUserData()
    await this.frontend.move_to_profile()

    return res
  }
}